<template>
<b-container>
<h1>Conferences</h1>
  <b-row>
    <b-col md="5" offset-md="7" class="my-1">
      <b-input-group>
        <b-form-input v-model="filter" placeholder="Type to Search" />
        <b-input-group-append>
        <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
        </b-input-group-append>
      </b-input-group>
    </b-col>
  </b-row>
  <b-table striped
           hover
           :items="conferences"
           :fields="fields"
           :filter="filter"
           stacked="md"
  >
  <template slot="title" slot-scope="data">
      {{data.item.title}}
  </template>
  <template v-slot:cell(description)="data">
    {{data.item.description | stripHTML }}
  </template>
  <template v-slot:cell(startDateTime)="data">
      {{data.item.startDateTime.seconds | moment("MM/DD/YYYY h:mm a") }}
  </template>
  <template v-slot:cell(registrationDateTime)="data">
      {{data.item.registrationDateTime.seconds | moment("MM/DD/YYYY, h:mm a") }}
  </template>
  <template v-slot:cell(actions)="data">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
        <b-button v-if="!data.item.publicConference" size="sm" variant="success" class="mr-1" :to="{ name: 'Register', params: { conferenceId: data.item.id } }">
          Register
        </b-button>
        <b-button v-if="data.item.publicConference" size="sm" variant="success" class="mr-1" :to="{ name: 'Public Register', params: { conferenceId: data.item.id } }">
          Public Registration
        </b-button>
  </template>
  </b-table>
</b-container>
</template>

<script>
import { db } from '../main'

export default {
  name: 'Conferences',
  filters: {
    stripHTML (value) {
      const div = document.createElement('div')
      div.innerHTML = value
      const text = div.textContent || div.innerText || ''
      return text
    },
    truncate (value, stop, clamp) {
      return value.slice(0, stop) + (stop < value.length ? clamp || '...' : '')
    }
  },
  data () {
    return {
      fields: [
        { key: 'title', label: 'Title', sortable: true },
        { key: 'description', label: 'Summary' },
        { key: 'startDateTime', label: 'Conference Date' },
        { key: 'registrationDateTime', label: 'Registration Deadline' },
        { key: 'actions', label: 'Actions' }
      ],
      conferences: [],
      filter: null
    }
  },
  firestore () {
    return {
      conferences: db.collection('Conferences').where('registrationDateTime', '>=', new Date()).where('conferenceActive', '==', true)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Conferences.vue